var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#10428E",
    strokeWidth: 0.4,
    d: "M7 4.499H4.5v2.5a.5.5 0 1 1-1 0v-2.5H1a.5.5 0 0 1 0-1h2.5v-2.5a.5.5 0 0 1 1 0v2.5H7a.5.5 0 1 1 0 1Z"
  })));
};
export default SvgPlus;